/* Evenly funnel pages: carry ad tracking through to the product page, sticky CTA bar */
(function () {
  // Pass the ad's UTM / fbclid parameters on to every CTA, so Meta and Shopify credit the right ad
  function withQuery(href) {
    var incoming = window.location.search;
    if (!incoming || !href || href.charAt(0) === '#') return href;
    try {
      var url = new URL(href, window.location.origin);
      new URLSearchParams(incoming).forEach(function (value, key) {
        if (!url.searchParams.has(key)) url.searchParams.set(key, value);
      });
      return url.origin === window.location.origin ? url.pathname + url.search + url.hash : url.toString();
    } catch (e) {
      return href;
    }
  }
  window.prWithQuery = withQuery;

  document.querySelectorAll('[data-pr-cta]').forEach(function (a) {
    a.setAttribute('href', withQuery(a.getAttribute('href')));
  });

  // Sticky bar: appears after the reader passes the headline, hides near the end
  var sticky = document.querySelector('[data-pr-sticky]');
  if (sticky) {
    var ticking = false;
    var update = function () {
      ticking = false;
      var y = window.scrollY;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var show = y > 600 && y < max - 500;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      var link = sticky.querySelector('a');
      if (link) link.tabIndex = show ? 0 : -1;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }
})();
